import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { FormControlLabel } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import { styled } from "@mui/material/styles";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import React, { useEffect, useState } from 'react';
import InnerHeader from "./InnerHeader";
//import FormGroup from '@mui/material/FormGroup';
//import FormControlLabel from '@mui/material/FormControlLabel';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import Checkbox from '@mui/material/Checkbox';
import { StyledDataGrid } from "./StyledDataGrid";
import { BASE_URL } from "./BaseUrl";
import axios from "axios";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
        padding: theme.spacing(2),
    },
    "& .MuiDialogActions-root": {
        padding: theme.spacing(1),
    },
}));


const FacultySalaryReport = () => {

    const [value, setValue] = useState([])
    const [hide, setHide] = useState(false)
    const [check, setccheck] = useState('')
    const [rotate, setrotate] = useState(false)
    const [salarydata, setsalarydata] = useState([])
    const [salarydataview, setsalaryviewdata] = useState([])
    const [faculty, setFaculty] = useState([])
    const [category, setCat] = useState('')
    const [paginationModel, setPaginationModel] = useState({
        pageSize: 50,
        page: 0,
    });

    const [filters, setFilters] = useState({
        viewTiming: false,
        pendingSalary: false
    });

    async function getFacultySalaryReport() {
        try {
            const response = await axios.get(`${BASE_URL}/getfaculty_masterdata`, {
                headers: {
                    "Content-Type": "application/json",
                }
            });

            setFaculty(response.data);

        } catch (error) {
            console.error("Error fetching faculty salary report:", error);

        }
    }


    useEffect(() => {
        getFacultySalaryReport();
    }, []);


    const handleSubmit = async (e) => {
        e.preventDefault();


        const body = {
            faculty: value.faculty,
            period: value.period,
            periodyear: value.periodyear,
        }

        if (filters.viewTiming == true) {
            try {
                const response = await axios.post(`${BASE_URL}/getsalaryviewreport`, body, {
                    headers: {
                        "Content-Type": "application/json",
                    },
                });

                setsalaryviewdata(response.data);
                setHide(true)

                setValue((prev => ({
                    ...prev,
                    faculty: "",
                    period: "",
                    periodyear: "",
                })))

                setsalarydata([])

            } catch (error) {
                console.error("Error fetching faculty salary report:", error);

            }
        } else {
            try {
                const response = await axios.post(`${BASE_URL}/getsalaryreport`, body, {
                    headers: {
                        "Content-Type": "application/json",
                    },
                });

                setsalarydata(response.data);
                setHide(true)

                setValue((prev => ({
                    ...prev,
                    faculty: "",
                    period: "",
                    periodyear: "",
                })))

                setsalaryviewdata([])

            } catch (error) {
                console.error("Error fetching faculty salary report:", error);

            }
        }


    }


    const exportToExcel = () => {
        const wb = XLSX.utils.book_new();

        const title = [["Faculty Salary Statement Report : "]];
        const headers = [
            ["Date", "Name", "PAN", "Charges P.H.", "Total Hours", "Amount", "T.D.S. %", "T.D.S. Amt", "Net Amt. Payble"]
        ];

        const body = salarydata.map(row => [
            row.Take_Dt,
            row.Faculty_Name,
            row.PAN,
            row.chargesperhour,
            row.TotalHours,
            row.amount,
            row.TDS,
            row.tds_amount,
            row.net_amount
        ]);

        // Calculate totals for the footer
        const totalAmount = salarydata.reduce((sum, r) => sum + parseFloat(r.amount || 0), 0);
        const totalTDS = salarydata.reduce((sum, r) => sum + parseFloat(r.tds_amount || 0), 0);
        const totalNetPay = salarydata.reduce((sum, r) => sum + parseFloat(r.net_amount || 0), 0);

        const footer = [
            ["", "", "", "", "", totalAmount, "", totalTDS, totalNetPay]
        ];

        // Combine all
        const fullData = [...title, [], ...headers, ...body, ...footer];

        const ws = XLSX.utils.aoa_to_sheet(fullData);

        // Merge cells for the title (A1 to I1)
        ws["!merges"] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: 8 } }];

        // Set column widths
        ws["!cols"] = new Array(9).fill({ wch: 18 });

        XLSX.utils.book_append_sheet(wb, ws, "SalaryReport");

        const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        const blob = new Blob([excelBuffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });

        saveAs(blob, "Faculty_Salary_Report_2025.xlsx");
    };



    const exportToExcelView = (year) => {
        const wb = XLSX.utils.book_new();

        // Title row
        const title = [[`Faculty Salary Statement Report : `]];

        // Headers for your given columns
        const headers = [
            [
                "ID",
                "Date",
                "Batch Code",
                "Faculty Name",
                "Start Time",
                "End Time",
                "Total Hours"
            ]
        ];

        // Body rows
        const body = salarydataview.map(row => [
            row.Take_Id,
            row.Take_Dt, // Already formatted dd-mm-yyyy in backend
            row.Batch_code,
            row.Faculty_Name,
            row.Faculty_Start,
            row.Faculty_End,
            row.TotalHours
        ]);

        // Totals row (only for Total Hours if needed)
        // If you want sum of hours, we can’t just sum HH:MM:SS strings — must convert to seconds first
        const totalSeconds = salarydataview.reduce((sum, r) => {
            if (!r.TotalHours) return sum;
            const [h, m, s] = r.TotalHours.split(":").map(Number);
            return sum + (h * 3600 + m * 60 + s);
        }, 0);

        const totalHH = String(Math.floor(totalSeconds / 3600)).padStart(2, "0");
        const totalMM = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, "0");
        const totalSS = String(totalSeconds % 60).padStart(2, "0");
        const totalTime = `${totalHH}:${totalMM}:${totalSS}`;

        const footer = [["", "", "", "", "", "Total", totalTime]];

        // Combine all parts
        const fullData = [...title, [], ...headers, ...body, ...footer];

        // Create worksheet
        const ws = XLSX.utils.aoa_to_sheet(fullData);

        // Merge title row (A1 to G1)
        ws["!merges"] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: 6 } }];

        // Set column widths
        ws["!cols"] = [
            { wch: 8 },  // ID
            { wch: 15 }, // Date
            { wch: 15 }, // Batch Code
            { wch: 25 }, // Faculty Name
            { wch: 15 }, // Start Time
            { wch: 15 }, // End Time
            { wch: 15 }  // Total Hours
        ];

        // Append sheet to workbook
        XLSX.utils.book_append_sheet(wb, ws, "SalaryReport");

        // Write and save file
        const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        const blob = new Blob([excelBuffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });

        saveAs(blob, `Faculty_Salary_Report.xlsx`);
    };



    const onhandleChange = (e) => {
        setValue((prev) => ({ ...prev, [e.target.name]: e.target.value }))
    }


    const columns = [
      {
    field: "Take_Dt",
    headerName: "Date",
    align: "center",
    headerAlign: "center",
    flex: 1,
    filterable: false,
    // renderCell: (params) => {
    //     if (!params.value) return "";

    //     // Handle yyyymmdd format from API
    //     if (/^\d{8}$/.test(params.value)) {
    //         const year = params.value.substring(0, 4);
    //         const month = params.value.substring(4, 6);
    //         const day = params.value.substring(6, 8);
    //         return `${day}-${month}-${year}`;
    //     }

    //     // Handle yyyy-mm-dd or Date object
    //     const date = new Date(params.value);
    //     if (isNaN(date.getTime())) return "";

    //     return `${String(date.getDate()).padStart(2, "0")}-${String(date.getMonth() + 1).padStart(2, "0")}-${date.getFullYear()}`;
    // },
},

        {
            field: "Faculty_Name",
            headerName: "Name",
            align: "center",
            headerAlign: "center",
            flex: 1,
            filterable: false,
        },
        {
            field: "PAN",
            headerName: "PAN",
            align: "center",
            headerAlign: "center",
            flex: 1,
            filterable: false,
        },
        {
            field: "chargesperhour",
            headerName: "CHARGES P.H",
            align: "center",
            headerAlign: "center",
            flex: 1,
            filterable: false,
            renderCell: (params) => params.value ? parseFloat(params.value).toFixed(2) : 0 ,
        },
        {
            field: "TotalHours",
            headerName: "TOTAL HOURS",
            align: "center",
            headerAlign: "center",
            flex: 1,
            filterable: false,
            renderCell: (params) =>
                // // If you already have total hours as decimal, convert to HH:mm:ss
                // let totalSeconds = Math.floor(params.value * 3600);
                // let hours = String(Math.floor(totalSeconds / 3600)).padStart(2, "0");
                // let minutes = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, "0");
                // let seconds = String(totalSeconds % 60).padStart(2, "0");
                // return `${hours}:${minutes}:${seconds}`;
                params.TotalHours


        },
        {
            field: "amount",
            headerName: "AMOUNT",
            align: "center",
            headerAlign: "center",
            flex: 1,
            filterable: false,
            renderCell: (params) => params.value ? parseFloat(params.value).toFixed(2) : 0,
        },
        {
            field: "TDS",
            headerName: "T. D. S.%",
            align: "center",
            headerAlign: "center",
            flex: 1,
            filterable: false,
            renderCell: (params) => params.value,
        },
        {
            field: "tds_amount",
            headerName: "T. D. S Amount",
            align: "center",
            headerAlign: "center",
            flex: 1,
            filterable: false,
            renderCell: (params) => params.value ? parseFloat(params.value).toFixed(2) : 0,
        },
        {
            field: "net_amount",
            headerName: "Net Amount Payable",
            align: "center",
            headerAlign: "center",
            flex: 1,
            filterable: false,
            renderCell: (params) => params.value ? parseFloat(params.value).toFixed(2) : 0,
        }
    ];

    const columns2 = [
       {
    field: 'Take_Dt',
    headerName: 'Date',
    align: 'center',
    headerAlign: 'center',
    flex: 1,
    filterable: false,
    // renderCell: (params) => {
    //     if (!params.value) return "";

    //     // If already DD-MM-YYYY
    //     const ddmmyyyyRegex = /^\d{2}-\d{2}-\d{4}$/;
    //     if (ddmmyyyyRegex.test(params.value)) {
    //         return params.value;
    //     }

    //     // If yyyymmdd (API style, no dashes)
    //     if (/^\d{8}$/.test(params.value)) {
    //         const year = params.value.substring(0, 4);
    //         const month = params.value.substring(4, 6);
    //         const day = params.value.substring(6, 8);
    //         return `${day}-${month}-${year}`;
    //     }

    //     // If yyyy-mm-dd or Date object
    //     const date = new Date(params.value);
    //     if (isNaN(date.getTime())) return "";

    //     return `${String(date.getDate()).padStart(2, "0")}-${String(date.getMonth() + 1).padStart(2, "0")}-${date.getFullYear()}`;
    // }
},

        {
            field: 'Batch_code',
            headerName: 'Batch Code',
            type: 'number',
            align: 'center',
            headerAlign: 'center',
            flex: 1,
            filterable: false,
        },
        {
            field: 'Faculty_Name',
            headerName: 'Name',
            type: 'number',
            align: 'center',
            headerAlign: 'center',
            flex: 1,
            filterable: false,
        },
        {
            field: 'Faculty_Start',
            headerName: 'In',
            type: 'number',
            align: 'center',
            headerAlign: 'center',
            flex: 1,
            filterable: false,
        },
        {
            field: 'Faculty_End',
            headerName: 'Out',
            type: 'number',
            align: 'center',
            headerAlign: 'center',
            flex: 1,
            filterable: false,
        },
        {
            field: 'TotalHours',
            headerName: 'Total Hours',
            type: 'number',
            align: 'center',
            headerAlign: 'center',
            flex: 1,
            filterable: false,
        }

    ];

    const rowsWithIds = salarydata.map((row, index) => ({ index: index + 1, ...row }));
    const rowsWithId2 = salarydataview.map((row, index) => ({ index: index + 1, ...row }));


    const handleviewchange = (event) => {
        const { name, checked } = event.target;
        console.log(name, checked);

        // Example state update:
        setFilters(prev => ({
            ...prev,
            [name]: checked
        }));
    };


    return (

        <div class="container-fluid page-body-warpper ">
            <InnerHeader />
            <div class="main-panel">
                <div class="content-wrapper">
                    <div class="row">
                        <div class="col-lg-12 grid-margin stretch-card">
                            <div class="card">
                                <div class="card-body">
                                    <h4 class="card-title">
                                        Faculty Monthly Salary Statement
                                    </h4>
                                    <hr></hr>

                                    <form class="form-sample py-3" onSubmit={handleSubmit} >
                                        <div class="row">

                                            <div class="form-group col-lg-3">
                                                <lable for="exampleFormControlSelect1">Faculty</lable>
                                                <select class="form-control" id="exampleFormControlSelect1"
                                                    value={value.faculty} name="faculty"
                                                    onChange={onhandleChange}>
                                                    <option>--Faculty Name--</option>
                                                    {faculty.map((item, index) => (
                                                        <option key={index} value={item.Faculty_Id}>{item.Faculty_Name}</option>
                                                    ))}
                                                    <option></option>
                                                </select>
                                            </div>

                                            <div class="form-group col-lg-2">
                                                <lable for="exampleFormControlSelect1">Period</lable>
                                                <select class="form-control" id="exampleFormControlSelecet1"
                                                    value={value.period} name="period"
                                                    onChange={onhandleChange}>
                                                    <option>--Select Months--</option>
                                                    <option value="January">January</option>
                                                    <option value="February">February</option>
                                                    <option value="March">March</option>
                                                    <option value="April">April</option>
                                                    <option value="May">May</option>
                                                    <option value="June">June</option>
                                                    <option value="July">July</option>
                                                    <option value="August">August</option>
                                                    <option value="September">September</option>
                                                    <option value="October">October</option>
                                                    <option value="November">November</option>
                                                    <option value="December">December</option>
                                                </select>
                                            </div>

                                            <div class="form-group col-lg-2">
                                                <lable for="exampleFormControlSelect1">Year</lable>
                                                <select class="form-control" id="exampleFormControlSelect1"
                                                    value={value.periodyear} name="periodyear"
                                                    onChange={onhandleChange}>
                                                    <option>--Select Year--</option>
                                                    <option value="2026">2026</option>
                                                    <option value="2025">2025</option>
                                                    <option value="2024">2024</option>
                                                    <option value="2023">2023</option>
                                                    <option value="2022">2022</option>
                                                    <option value="2021">2021</option>
                                                    <option value="2020">2020</option>
                                                    <option value="2019">2019</option>
                                                    <option value="2018">2018</option>
                                                    <option value="2017">2017</option>
                                                    <option value="2016">2016</option>
                                                    <option value="2015">2015</option>
                                                    <option value="2014">2014</option>
                                                    <option value="2013">2013</option>
                                                    <option value="2012">2012</option>
                                                    <option value="2011">2011</option>
                                                </select>
                                            </div>

                                            <FormControlLabel
                                                control={<Checkbox name="viewTiming" onChange={handleviewchange} />}
                                                label="View Timing"
                                            />

                                            <FormControlLabel
                                                control={<Checkbox name="pendingSalary" onChange={handleviewchange} />}
                                                label="For Pending Salary"
                                            />

                                            <div class="d-flex align-items-center mt-3">
                                                <button type="submit" class="btn btn-sm btn-primary mr-2 py-2">Go</button>
                                            </div>
                                            <div class="d-flex align-items-center mt-3">
                                                <button type="button" class="btn btn-sm btn-primary mr-2 py-2" onClick={()=>{
                                                    window.location.reload()
                                                }}>Clear</button>
                                            </div>


                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>

                        {hide && <div class="col-lg-12">
                            {filters.viewTiming == true ? <div class="card">
                                <div class="card-body">
                                    <div className="d-flex justify-content-wrrper" style={{ borderBottom: "2px solid #dce4ec", width: "100%" }}>
                                        <div>
                                            <h4 class="card-title">
                                                Details
                                            </h4>
                                        </div>
                                    </div>

                                    <div style={{ borderLeft: "1px solid #dce4ec", height: "510px", overflow: "hidden" }}>
                                        <StyledDataGrid
                                            rows={rowsWithId2}
                                            columns={columns2}
                                            // disableColumnFilter
                                            disableColumnSelector
                                            disableDensitySelector
                                            rowHeight={35}
                                            getRowId={(row) => row.Take_Id}
                                            pagination
                                            paginationModel={paginationModel}
                                            onPaginationModelChange={setPaginationModel}
                                            pageSizeOptions={[50]}
                                            autoHeight={false}
                                            sx={{
                                                height: 500, // Ensure enough height for pagination controls
                                                '& .MuiDataGrid-footerContainer': {
                                                    justifyContent: 'flex-end',
                                                },
                                            }}
                                            // slots={{
                                            //     toolbar: GridToolbar
                                            // }}
                                            slotProps={{
                                                toolbar: {
                                                    showQuickFilter: true,
                                                },
                                            }}
                                        />
                                    </div>

                                    <button type="submit" class="btn btn-primary mr-2" onClick={exportToExcelView}>Excel</button>
                                    <button type='button' onClick={() => {
                                        window.location.reload()
                                    }} class="btn btn-light">Back</button>
                                </div>
                            </div> : <div class="card">
                                <div class="card-body">
                                    <div className="d-flex justify-content-wrrper" style={{ borderBottom: "2px solid #dce4ec", width: "100%" }}>
                                        <div>
                                            <h4 class="card-title">
                                                Details
                                            </h4>
                                        </div>
                                    </div>

                                    <div style={{ borderLeft: "1px solid #dce4ec", height: "510px", overflow: "hidden" }}>
                                        <StyledDataGrid
                                            rows={rowsWithIds}
                                            columns={columns}
                                            // disableColumnFilter
                                            disableColumnSelector
                                            disableDensitySelector
                                            rowHeight={35}
                                            getRowId={(row) => row.Take_Id}
                                            pagination
                                            paginationModel={paginationModel}
                                            onPaginationModelChange={setPaginationModel}
                                            pageSizeOptions={[50]}
                                            autoHeight={false}
                                            sx={{
                                                height: 500, // Ensure enough height for pagination controls
                                                '& .MuiDataGrid-footerContainer': {
                                                    justifyContent: 'flex-end',
                                                },
                                            }}
                                            // slots={{
                                            //     toolbar: GridToolbar
                                            // }}
                                            slotProps={{
                                                toolbar: {
                                                    showQuickFilter: true,
                                                },
                                            }}
                                        />
                                    </div>

                                    <button type="submit" class="btn btn-primary mr-2" onClick={exportToExcel}>Excel</button>
                                    <button type='button' onClick={() => {
                                        window.location.reload()
                                    }} class="btn btn-light">Back</button>
                                </div>
                            </div>}

                        </div>}
                    </div>
                </div>
            </div>
        </div>

    )
}

export default FacultySalaryReport